module.exports = __webpack_public_path__ + "img/preview-7.67bfca4e.webp";